import React, { useState } from 'react';
import { AllowedGuard } from 'components/Tvendo/Common/UserAction';
import { ConstantPermissions } from 'contexts/useConstant';
import { makeStyles } from '@material-ui/core/styles';
import { Create, FileCopySharp, Visibility } from '@material-ui/icons';
import Button from 'components/CustomButtons/Button.js';
import { Link } from 'react-router-dom';
//iconos
import { Add } from '@material-ui/icons';

//tabla y card components
import GridContainer from 'components/Grid/GridContainer.js';
import GridItem from 'components/Grid/GridItem.js';
import Card from 'components/Card/Card.js';
import CardBody from 'components/Card/CardBody.js';
import CardIcon from 'components/Card/CardIcon.js';
import CardHeader from 'components/Card/CardHeader.js';
import ReactTable from 'components/ReactTable/ReactTableV2.js';
import { cardTitle } from 'assets/jss/material-dashboard-pro-react.js';
import LoadingSpinner from 'components/Tvendo/Common/LoadingSpinner';
//modal
import Modal from './Modal';
import { useModal } from 'hooks/useModal';
import { Toasty, useToasty } from 'hooks/Toasty';
import ButtonDelete from 'hooks/ButtonDelete';
import { WithApp } from 'contexts/appContext';
import FilterCustom from 'components/Tvendo/Common/FilterCustom';
import { wsFindBy } from 'services/WService';

const styles = {
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px'
  }
};
const useStyles = makeStyles(styles);

//columnas para llenar la tabla
const columns = [
  { Header: '#', accessor: 'num', excelEnabled: false, width: 180 },
  { Header: 'Día Prog.', accessor: 'dayDescription', width: 170 },
  { Header: 'Nombre Vehiculo', accessor: 'vehicle_name' },
  { Header: 'Placa Vehiculo', accessor: 'vehicle_code', width: 150 },
  { Header: 'Año Vehiculo', accessor: 'vehicle_year', width: 120 },
  { Header: 'Zona Vehiculo', accessor: 'vehicle_zone_description', width: 130 },
  { Header: 'Jefe mercadería', accessor: 'inventory_manager_name' },
  { Header: 'DNI Jefe mercadería', accessor: 'inventory_manager_code', width: 140 },
  { Header: 'Nombre Conductor', accessor: 'manager_name' },
  { Header: 'DNI Conductor', accessor: 'manager_code', width: 140 },
  { Header: 'Lic. Conductor', accessor: 'manager_driver_license', width: 130 },
  { Header: 'Estado', accessor: 'state', width: 100 },
  { Header: '', accessor: 'actions', excelEnabled: false, width: 0 }
];

export default WithApp(function Config(props) {
  const classes = useStyles();
  const [model, setOpen] = useModal();
  const [notify, showNotify] = useToasty();
  const [config, setConfig] = useState([]);
  const [dataLoading, setDataLoading] = useState(false);
  const [valueSearch, setValueSearch] = useState({});

  async function loadConfig(filter) {
    setDataLoading(true);
    let response = await wsFindBy('prog/program-config',filter);
    setDataLoading(false);
    if (response.success) setConfig(response.data);
  }

  return (
    <GridContainer>
      <Toasty action={notify} />
      {model.open ? (
        <Modal
          model={model}
          setOpen={setOpen}
          showNotify={showNotify}
          reload={() => loadConfig(valueSearch)}
        />
      ) : undefined}

      <GridItem xs={12}>
        <Card>
          <CardHeader icon>
            <AllowedGuard
              permission={ConstantPermissions.DELIV_JORNADAS_INICIAR_JORNADA}
              component={
                <CardIcon color="primary">
                  <FileCopySharp style={{ color: 'white' }} />
                </CardIcon>
              }
            >
              <CardIcon
                onClick={() => setOpen({})}
                pointer="true"
                color={props.themeContext.buttonColorSuccess}
              >
                <Add />
              </CardIcon>
            </AllowedGuard>
            <h4 className={classes.cardIconTitle}>Listado de configuración de programación {dataLoading && <LoadingSpinner />}</h4>
          </CardHeader>
          <CardBody>
            <FilterCustom
              getFilter={loadConfig}
              getValueSearch={(value) => {
                setValueSearch(value);
              }}
              dateWeek
              zone
            />
            <ReactTable
              excelName="configuracion_de_programacion"
              formatDate="DD-MM-YYYY"
              columns={columns}
              data={config.map((item, i) => {
                return {
                  num: (
                    <div className="actions-right">
                      {i + 1}
                      <AllowedGuard permission={ConstantPermissions.DELIV_JORNADAS_INICIAR_JORNADA}>
                        <Button justIcon round simple color={props.themeContext.buttonColorWarning}>
                          <Link to={`${item.id}`}>
                            <Visibility />
                          </Link>
                        </Button>
                      </AllowedGuard>
                      <AllowedGuard permission={ConstantPermissions.DELIV_JORNADAS_INICIAR_JORNADA}>
                        <Button
                          justIcon
                          round
                          simple
                          color={props.themeContext.buttonColorWarning}
                          onClick={() => setOpen(item)}
                        >
                          <Create />
                        </Button>
                      </AllowedGuard>
                      <AllowedGuard permission={ConstantPermissions.DELIV_JORNADAS_INICIAR_JORNADA} >
                        <ButtonDelete
                          entity="prog/program-config"
                          id={item.id}
                          
                          reload={() => {
                            setDataLoading(true);
                            loadConfig(valueSearch).then(() => setDataLoading(false));
                        }}
                        />
                      </AllowedGuard>
                    </div>
                  ),
                  program_date: item.program_date,
                  state: item.state === 'A' ? 'Activo' : 'Inactivo',
                  dayDescription: item.day?.description,
                  vehicle_code: item.vehicle?.code,
                  vehicle_name: item.vehicle?.name,
                  vehicle_year: item.vehicle?.year,
                  vehicle_zone_description: item.vehicle?.zone?.description,
                  inventory_manager_name: item.inventory_manager?.name,
                  inventory_manager_code: item.inventory_manager?.code,
                  manager_code: item.manager?.code,
                  manager_name: item.manager?.name,
                  manager_driver_license: item.manager?.driver_license,
                  actions: '',
                };
              })}
            />
          </CardBody>
        </Card>
      </GridItem>
    </GridContainer>
  );
});
